export const SET_SITE_SCHEDULE_ACTIVITY_PAGE_INDEX = '@siteScheduleActivity/SET_SITE_SCHEDULE_ACTIVITY_PAGE_INDEX';
export const SET_SITE_SCHEDULE_ACTIVITY_SORT = '@siteScheduleActivity/SET_SITE_SCHEDULE_ACTIVITY_SORT';
export const SET_SITE_SCHEDULE_ACTIVITY_FILTERS = '@siteScheduleActivity/SET_SITE_SCHEDULE_ACTIVITY_FILTERS';
export const RESET_SITE_SCHEDULE_ACTIVITY_FILTERS = '@siteScheduleActivity/RESET_SITE_SCHEDULE_ACTIVITY_FILTERS';

export const FETCH_SITE_SCHEDULE_ACTIVITY_REQUEST = '@siteScheduleActivity/FETCH_SITE_SCHEDULE_ACTIVITY_REQUEST';
export const FETCH_SITE_SCHEDULE_ACTIVITY_SUCCESS = '@siteScheduleActivity/FETCH_SITE_SCHEDULE_ACTIVITY_SUCCESS';
export const FETCH_SITE_SCHEDULE_ACTIVITY_FAILED = '@siteScheduleActivity/FETCH_SITE_SCHEDULE_ACTIVITY_FAILED';
